import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AppPermission } from '@app/core/enums/app-permission.enum';
import { AppProfile } from '@app/core/enums/app-profile.enum';
import { LoggerService } from '@app/core/services/logger.service';
import { RolePermissionsService } from '@app/core/services/role-permissions.service';
import { SaveObjectInLocalServiceService } from '@app/core/services/save-object-in-local-service.service';
import { AppProfilePermission } from '../models/app-profile-permission.model';

const logger = new LoggerService('AppPermissionDirective');

@Directive({
  selector: '[dhlAppPermission]'
})
export class AppPermissionDirective {
  private readonly currentProfile!: AppProfile;
  private profilesToValidate: AppProfile[] = [];
  private currentPermissions: string[] = [];
  private permissions: AppPermission[] = [];

  constructor(
    private readonly templateRef: TemplateRef<unknown>,
    private readonly viewContainer: ViewContainerRef,
    private readonly rolePermissionsService: RolePermissionsService,
    private readonly storage: SaveObjectInLocalServiceService
  ) {
    this.currentProfile = this.storage.getObject('profile') as AppProfile;
  }

  ngOnInit() {
    this.rolePermissionsService.currentPermissions.subscribe((value) => {
      this.currentPermissions = value;
    });
  }

  @Input()
  set dhlAppPermission(configuration: AppProfilePermission) {
    this.profilesToValidate = configuration.profiles;
    this.permissions = configuration.permissions;
    this.updateView();
  }

  private updateView() {
    if (this.checkPermission()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  private checkPermission(): boolean {
    let hasPermission = false;
    if (this.profilesToValidate.length === 0 || this.profilesToValidate.includes(this.currentProfile)) {
      const permissions = (this.storage.getObject('permissions') as string).replace(/&#34;/g, '"');
      this.currentPermissions = JSON.parse(permissions) as string[];
      if (this.currentPermissions.length > 0) {
        hasPermission = this.permissions.some((p) => this.currentPermissions.includes(p));
      }

      return hasPermission;
    } else {
      return hasPermission;
    }
  }
}
